import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import { App } from '@/app/app';
import '@/styles/index.css';

const rootEl = document.getElementById('root');
if (!rootEl) throw new Error('Root container #root is missing in index.html');

createRoot(rootEl).render(
  <StrictMode>
    <App />
  </StrictMode>
);
